import transparencyEyeIcon from '../../Assets/images/transparency_guarantee_eye.png';
import verificationIcon from '../../Assets/images/load_visibility_verification.png';
import gtaIcon from '../../Assets/images/about_us_gta.png';
import statusIcon from '../../Assets/images/load_visibility_status.png';

export const ABOUT_BANNER = {
  headingLine1: "Ontario's Digital Hub for",
  headingHighlight: 'Heavy Hauling',
  description:
    "At HaulSync, we keep it simple: we connect vetted dump truck drivers with Ontario's top construction firms. We built this platform to modernize traditional brokerage by eliminating manual processes like phone tag and paper tickets.",
};

export const ABOUT_STORY = {
  imageAlt: 'Two dump trucks hauling on an Ontario highway',
  sections: [
    {
      id: 'what-we-do',
      headingPrefix: 'What',
      headingHighlight: 'We Do',
      description:
        'We enable businesses to post jobs, drivers to accept them instantly, and operations to run without unnecessary back-and-forth. With real-time updates and automated invoicing, every step is simplified — so teams can focus on getting the job done.',
    },
    {
      id: 'our-approach',
      headingPrefix: 'Our',
      headingHighlight: 'Approach',
      description:
        'We believe logistics should be straightforward. Our approach focuses on clarity, speed, and reliability — removing friction from daily operations and replacing it with systems that just work.',
    },
    {
      id: 'why-it-matters',
      headingPrefix: 'Why It',
      headingHighlight: 'Matters',
      description:
        'In fast-moving environments, delays and miscommunication cost time and money. By creating a single source of truth for jobs, drivers, and deliveries, we help businesses operate with confidence and consistency.',
    },
  ],
};

export const WHY_WORK_WITH_US = {
  headingPrefix: 'Why',
  headingHighlight: 'Work',
  headingSuffix: 'With Us?',
  cards: [
    {
      id: 'flat-fee',
      icon: transparencyEyeIcon,
      iconAlt: 'Transparency eye icon',
      title: 'Transparent 5% Flat Fee',
      description:
        'We keep pricing simple and honest with a fixed 5% fee, ensuring carriers retain the majority of their earnings without hidden costs.',
      delay: '0ms',
    },
    {
      id: 'wsib-cvor',
      icon: verificationIcon,
      iconAlt: 'Verification checkmark icon',
      title: 'WSIB & CVOR Compliant Drivers',
      description:
        'Every driver on our platform is pre-screened to meet WSIB, insurance, and MTO/CVOR standards, ensuring safety, compliance, and reliability.',
      delay: '100ms',
    },
    {
      id: 'gta-expertise',
      icon: gtaIcon,
      iconAlt: 'GTA region map icon',
      title: 'Deep Local GTA Expertise',
      description:
        'With strong roots across the GTHA, we understand local routes, quarry operations, and job site demands to ensure smoother logistics.',
      delay: '200ms',
    },
    {
      id: 'load-tracking',
      icon: statusIcon,
      iconAlt: 'Load status tracking icon',
      title: 'Real-Time Load Tracking',
      description:
        'Track every load from dispatch to delivery in real time, giving you full visibility and control directly from your mobile device.',
      delay: '300ms',
    },
  ],
};
